import React from "react";
import api from "../../services/api";
import Navbar from "../../components/navbar/index.jsx";
import imagem from "../../assets/Adobe.png"
import {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import {useParams}  from 'react-router-dom';

import "./listadata.css";

function ListaData(props){

    var NomeUsuario = localStorage.getItem("NomeUsuario");
    let [dados,setdados] = useState([])
    let [qtde,setQtde] = useState(0)
    let [qtraiz,setQtRaiz] = useState(0)
    let [raiz,setraiz] = useState([])
    const parametros = useParams(); 
    
    async function CarregaDocto()
    {
       const cnpj = localStorage.getItem("usuario");

        //const resultado = await api.get('/lstPdf/?p=' + cnpj+'&t='+props.tipo+'&o'+props.IdExec);
        const resultado = await api.get('/lstData/?p=' + cnpj+'&t='+parametros.Tipo.substring(0, 1)+'&a='+parametros.Tipo.substring(1,5));
        setdados(resultado.data)   
        setQtde(resultado.data[0].IdFtp) 

        const resultRaiz = await api.get('/lstData/ListaRaiz.php/?p=' + cnpj+'&t='+parametros.Tipo.substring(0, 1)+'&a='+parametros.Tipo.substring(1,5));
        setraiz(resultRaiz.data)
        setQtRaiz(resultRaiz.data[0].IdFtp) 
   

    }

    useEffect(()=>{
          CarregaDocto()
    },[]  );

   return<>
               
               { qtde === 0 ?
               
                    <div className="alert alert-secondary mt-2" role="alert">
                            Nenhum item a ser exibido !
                    </div>
                  :    
                  <div>
                         <Navbar/>     
                         <div className="m-2 mt-4 ">
                               <div className="invisivel">
                                    <h6> '' </h6> 
                                    <h1> '' </h1> 
                               </div> 
                               <h6> {NomeUsuario} </h6>
                         </div>   
                        
                              <div className="row">   
                                   
                                   { raiz.map(function(dir){
                                     
                                                  return  <div className="col-md-4">
                                                                 <div className="raiz">
                                                                      
                                                                         
                                                                           <a href={dir.Arquivo}  target="_blank"> {dir.NomeRelatorio} </a> 
                                                                      
                                                                    
                                                                 </div> 
                                                            </div>   })

                                             }      
                              </div>  
                            
                              <hr/>
                                    <div className="Periodo"> 
                                             Escolha o mês desejado
                                   </div>         
                              <hr/>
                              <div className="row">   
                                        
                                   { dados.map(function(dado){
                                                  return  <div className="col-md-4">
                                                                 <div className="card">
                                                                      <div className="card-header text-center">
                                                                           <Link 
                                                                                to={'/listadocumento/'+parametros.Tipo.substring(0, 1)+parametros.Tipo.substring(1,5)+dado.Mes} > 
                                                                                <i className="fas fa-calendar-day"></i>{dado.NmMes}
                                                                           </Link>                                                                
                                                                      </div>
                                                                      <div className="card-body text-center ">
                                                                           <p  className="card-text"> Ano :  {dado.Ano} </p>                                           
                                                                      </div>
                                                                 </div>
                                                            </div>  })

                                             }      
                              </div>   
                    </div>
             }

</>

}

export default ListaData;
